import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import RoleTableContainer from '../containers/role-table.container';
import RoleDetailsContainer from '../containers/role-details.container';
import RoleCreateContainer from '../containers/role-create.container';
import RoleUpdateContainer from '../containers/role-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';
import TenantGuard from '@components/common/TenantGuard';

// Helper function to add default query parameters to the role list page
const RoleListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <RoleTableContainer />;
};

export const roleRoutes = [
  {
    path: 'role',
    element: (
      <TenantGuard showHeader={true} headerTitle="Role List" showBreadcrumbs={true}>
        <RoleListWithParams />
      </TenantGuard>
    ),
  },
  {
    path: 'role/create',
    element: (
      <TenantGuard showHeader={true} headerTitle="Create Role" showBreadcrumbs={true}>
        <RoleCreateContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'role/:id',
    element: (
      <TenantGuard showHeader={true} headerTitle="Role Details" showBreadcrumbs={true}>
        <RoleDetailsContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'role/:id/update',
    element: (
      <TenantGuard showHeader={true} headerTitle="Update Role" showBreadcrumbs={true}>
        <RoleUpdateContainer />
      </TenantGuard>
    ),
  },
];

export default roleRoutes;
